module.exports = __webpack_public_path__ + "static/img/13.78623c98.png";